module.exports = __webpack_public_path__ + "static/media/shanti jewwllers png logo.da5813cf.PNG";